import { render, staticRenderFns } from "./FinancialService.vue?vue&type=template&id=33fb0ac4"
import script from "./FinancialService.vue?vue&type=script&lang=js"
export * from "./FinancialService.vue?vue&type=script&lang=js"
import style0 from "./FinancialService.vue?vue&type=style&index=0&id=33fb0ac4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports